/**
 * fixMojibake — Corrige doble-encoding UTF-8 ↔ Latin-1/CP1252 en strings.
 *
 * Mismo algoritmo que functions/src/utils/validaciones.ts:fixMojibake
 * pero adaptado para el browser (sin Buffer).
 *
 * Aplicar en display de nombres/strings que provengan de fuentes con
 * encoding sospechoso (típicamente integraciones legacy).
 *
 * Idempotente: si el string ya está bien, retorna sin cambios.
 */
export function fixMojibake(str: string): string {
  if (!str || typeof str !== 'string') return str;
  if (!/[Ããâ]/.test(str)) return str;

  try {
    // Estrategia 1: round-trip Latin-1 → UTF-8 (sin Buffer en browser).
    const codepoints = [...str].map((c) => c.codePointAt(0) ?? 0);
    if (codepoints.every((cp) => cp < 256)) {
      // Construir Uint8Array con los codepoints como bytes
      const bytes = new Uint8Array(codepoints);
      const decoded = new TextDecoder('utf-8', { fatal: false }).decode(bytes);
      if (!decoded.includes('�')) {
        return decoded;
      }
    }

    // Estrategia 2: tabla de reemplazos directos
    const REPLACEMENTS: Array<[string, string]> = [
      ['ã‰', 'É'],
      ['ã“', 'Ó'],
      ['ãš', 'Ú'],
      ['ã‘', 'Ñ'],
      ['Ã‰', 'É'],
      ['Ã“', 'Ó'],
      ['Ãš', 'Ú'],
      ['Ã‘', 'Ñ'],
      ['Ã¡', 'á'],
      ['Ã©', 'é'],
      ['Ã­', 'í'],
      ['Ã³', 'ó'],
      ['Ãº', 'ú'],
      ['Ã±', 'ñ'],
      ['Ã¼', 'ü'],
      ['â€œ', '“'],
      ['â€', '”'],
      ['â€™', '’'],
      ['â€˜', '‘'],
      ['â€“', '–'],
      ['â€”', '—'],
      ['â€¦', '…'],
      ['â‚¬', '€'],
    ];

    let out = str;
    for (const [bad, good] of REPLACEMENTS) {
      if (out.includes(bad)) {
        out = out.split(bad).join(good);
      }
    }

    // Heurística final: ã/Ã seguida de letra mayúscula → Á
    out = out.replace(/ã(?=[A-Z])/g, 'Á');
    out = out.replace(/Ã(?=[A-Z])/g, 'Á');

    return out;
  } catch {
    return str;
  }
}
